import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, CheckIcon, MailIcon } from 'lucide-react';
import { ProjectCarousel } from '../components/ProjectCarousel';
export function CreativeDirection() {
  return <div className="w-full min-h-screen bg-stone-50" data-id="element-1306">
      {/* Header */}
      <header className="py-4 px-6 bg-white border-b border-stone-200" data-id="element-1307">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-1308">
          <Link to="/" className="inline-flex items-center gap-2 text-stone-600 hover:text-stone-900 transition-colors" data-id="element-1309">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-1310" />
            <span className="font-light" data-id="element-1311">Back to Home</span>
          </Link>
          <h1 className="text-2xl font-light text-stone-900" data-id="element-1312">Maria Elina</h1>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-10 px-6 bg-gradient-to-br from-stone-50 via-emerald-50/30 to-stone-50" data-id="element-1313">
        <div className="max-w-7xl mx-auto text-center" data-id="element-1314">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-1315">
            <h2 className="text-5xl md:text-7xl font-light text-stone-900 mb-4 flex flex-col items-center gap-2" data-id="element-1316">
              <img src="https://storage.yandexcloud.net/maria-images/images/design direction.svg" alt="Design Direction" className="md:w-16 md:h-16 w-10 h-10" data-id="element-1317" />
              Design Direction
            </h2>
            <p className="text-xl text-stone-600 font-light max-w-2xl mx-auto" data-id="element-1318">
              Strategic creative vision that brings multidisciplinary projects
              to life with cohesion and impact
            </p>
          </motion.div>
        </div>
      </section>

      {/* Service Packages Section */}
      <section className="py-20 px-6 pt-[40px]" data-id="element-1319">
        <div className="max-w-7xl mx-auto" data-id="element-1320">
          {/* Section Header */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-center mb-16" data-id="element-1321">
            <div className="relative inline-block" data-id="element-1322">
              <h3 className="text-4xl md:text-5xl font-extralight text-stone-900 mb-6 tracking-tight" data-id="element-1323">
                Service Packages
              </h3>
              <motion.div initial={{
              scaleX: 0
            }} whileInView={{
              scaleX: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              delay: 0.2
            }} className="absolute -bottom-2 left-0 right-0 h-[2px] bg-emerald-600" style={{
              clipPath: 'polygon(10% 0, 90% 0, 100% 100%, 0 100%)'
            }} data-id="element-1324" />
            </div>
          </motion.div>

          {/* Full Package - Featured */}
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} whileHover={{
          y: -8
        }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 mb-8" style={{
          clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
        }} data-id="element-1325">
            {/* Holographic gradient background */}
            <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/15 via-teal-400/15 to-cyan-400/15" data-id="element-1326" />
            <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-1327" />

            {/* Featured badge */}
            <div className="absolute top-3 right-3 md:top-6 md:right-6" data-id="element-1328">
              <span className="inline-block px-2.5 py-1 text-xs md:px-4 md:py-1.5 md:text-sm font-light text-emerald-700 bg-emerald-100 rounded-full border border-emerald-200" data-id="element-1329">
                Complete Solution
              </span>
            </div>

            <div className="relative z-10 p-10" data-id="element-1330">
              <h4 className="text-3xl font-light text-stone-900 mb-8 tracking-tight" data-id="element-1331">
                Full Package
              </h4>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-1332">
                {/* Column 1 */}
                <div data-id="element-1333">
                  <h5 className="text-lg font-medium text-emerald-700 mb-4 tracking-wide" data-id="element-1334">
                    Creative Strategy
                  </h5>
                  <ul className="space-y-3" data-id="element-1335">
                    <li className="flex items-start gap-3" data-id="element-1336">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1337" />
                      <span className="text-stone-700 font-light" data-id="element-1338">
                        Brand vision development
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-1339">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1340" />
                      <span className="text-stone-700 font-light" data-id="element-1341">
                        Creative brief & concept
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-1342">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1343" />
                      <span className="text-stone-700 font-light" data-id="element-1344">
                        Mood boards & references
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-1345">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1346" />
                      <span className="text-stone-700 font-light" data-id="element-1347">
                        Art direction guidelines
                      </span>
                    </li>
                  </ul>
                </div>

                {/* Column 2 */}
                <div data-id="element-1348">
                  <h5 className="text-lg font-medium text-emerald-700 mb-4 tracking-wide" data-id="element-1349">
                    Execution Oversight
                  </h5>
                  <ul className="space-y-3" data-id="element-1350">
                    <li className="flex items-start gap-3" data-id="element-1351">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1352" />
                      <span className="text-stone-700 font-light" data-id="element-1353">
                        Design team coordination
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-1354">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1355" />
                      <span className="text-stone-700 font-light" data-id="element-1356">
                        Quality control & review
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-1357">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1358" />
                      <span className="text-stone-700 font-light" data-id="element-1359">
                        Brand consistency management
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-1360">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1361" />
                      <span className="text-stone-700 font-light" data-id="element-1362">
                        Final delivery & handover
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Enquire Button */}
              <div className="mt-10" data-id="element-1363">
                <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Full%20Package%20%E2%80%93%20Design%20Direction&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Full%20Package%20for%20Design%20Direction%2C%20which%20includes%3A%0D%0A%0D%0ACreative%20Strategy%3A%0D%0A%E2%80%A2%20Brand%20vision%20development%0D%0A%E2%80%A2%20Creative%20brief%20%26%20concept%0D%0A%E2%80%A2%20Mood%20boards%20%26%20references%0D%0A%E2%80%A2%20Art%20direction%20guidelines%0D%0A%0D%0AExecution%20Oversight%3A%0D%0A%E2%80%A2%20Design%20team%20coordination%0D%0A%E2%80%A2%20Quality%20control%20%26%20review%0D%0A%E2%80%A2%20Brand%20consistency%20management%0D%0A%E2%80%A2%20Final%20delivery%20%26%20handover%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                y: -3
              }} className="group/btn inline-block relative" data-id="element-1364">
                  <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                  clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                }} data-id="element-1365" />
                  <div className="relative px-6 py-2 bg-emerald-600 text-white overflow-hidden mx-3 my-1.5" style={{
                  clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                }} data-id="element-1366">
                    <div className="absolute inset-0 bg-emerald-700 translate-y-[100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-1367" />
                    <span className="text-lg font-light relative z-10 inline-flex items-center gap-2" data-id="element-1368">
                      <MailIcon className="w-4 h-4" data-id="element-1369" />
                      Enquire
                    </span>
                  </div>
                </motion.a>
              </div>
            </div>

            {/* Angular corner accents */}
            <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-1370" />
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-1371" />
          </motion.div>

          {/* Other Packages Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1372">
            {/* Creative Strategy */}
            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} whileHover={{
            y: -8
          }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 h-full" style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
          }} data-id="element-1373">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 via-teal-400/10 to-cyan-400/10" data-id="element-1374" />
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-1375" />

              <div className="relative z-10 p-8 h-full flex flex-col" data-id="element-1376">
                <h4 className="text-2xl font-light text-stone-900 mb-6 tracking-tight" data-id="element-1377">
                  Creative Strategy
                </h4>
                <ul className="space-y-3 flex-grow" data-id="element-1378">
                  <li className="flex items-start gap-3" data-id="element-1379">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1380" />
                    <span className="text-stone-700 font-light" data-id="element-1381">
                      Brand vision development
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1382">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1383" />
                    <span className="text-stone-700 font-light" data-id="element-1384">
                      Creative brief
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1385">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1386" />
                    <span className="text-stone-700 font-light" data-id="element-1387">
                      Mood boards & art direction
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1388">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1389" />
                    <span className="text-stone-700 font-light" data-id="element-1390">
                      Visual language definition
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1391">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1392" />
                    <span className="text-stone-700 font-light" data-id="element-1393">
                      Presentation package
                    </span>
                  </li>
                </ul>

                {/* Enquire Button */}
                <div className="mt-6" data-id="element-1394">
                  <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Creative%20Strategy&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Creative%20Strategy%20package%2C%20which%20includes%3A%0D%0A%E2%80%A2%20Brand%20vision%20development%0D%0A%E2%80%A2%20Creative%20brief%0D%0A%E2%80%A2%20Mood%20boards%20%26%20art%20direction%0D%0A%E2%80%A2%20Visual%20language%20definition%0D%0A%E2%80%A2%20Presentation%20package%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                  y: -2
                }} className="group/btn inline-block relative" data-id="element-1395">
                    <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                    clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                  }} data-id="element-1396" />
                    <div className="relative px-5 py-1.5 bg-transparent overflow-hidden mx-3 my-1.5" style={{
                    clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                  }} data-id="element-1397">
                      <div className="absolute inset-0 bg-emerald-600 translate-y-[-100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-1398" />
                      <span className="text-base font-light relative z-10 inline-flex items-center gap-2 text-emerald-600 group-hover/btn:text-white transition-colors duration-300" data-id="element-1399">
                        <MailIcon className="w-4 h-4" data-id="element-1400" />
                        Enquire
                      </span>
                    </div>
                  </motion.a>
                </div>
              </div>

              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-1401" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-1402" />
            </motion.div>

            {/* Visual Direction */}
            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} whileHover={{
            y: -8
          }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 h-full" style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
          }} data-id="element-1403">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 via-teal-400/10 to-cyan-400/10" data-id="element-1404" />
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-1405" />

              <div className="relative z-10 p-8 h-full flex flex-col" data-id="element-1406">
                <h4 className="text-2xl font-light text-stone-900 mb-6 tracking-tight" data-id="element-1407">
                  Visual Direction
                </h4>
                <ul className="space-y-3 flex-grow" data-id="element-1408">
                  <li className="flex items-start gap-3" data-id="element-1409">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1410" />
                    <span className="text-stone-700 font-light" data-id="element-1411">
                      Design language development
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1412">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1413" />
                    <span className="text-stone-700 font-light" data-id="element-1414">
                      Style guides & standards
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1415">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1416" />
                    <span className="text-stone-700 font-light" data-id="element-1417">
                      Template creation
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1418">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1419" />
                    <span className="text-stone-700 font-light" data-id="element-1420">
                      Visual asset direction
                    </span>
                  </li>
                </ul>

                {/* Enquire Button */}
                <div className="mt-6" data-id="element-1421">
                  <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Visual%20Direction&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Visual%20Direction%20package%2C%20which%20includes%3A%0D%0A%E2%80%A2%20Design%20language%20development%0D%0A%E2%80%A2%20Style%20guides%20%26%20standards%0D%0A%E2%80%A2%20Template%20creation%0D%0A%E2%80%A2%20Visual%20asset%20direction%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                  y: -2
                }} className="group/btn inline-block relative" data-id="element-1422">
                    <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                    clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                  }} data-id="element-1423" />
                    <div className="relative px-5 py-1.5 bg-transparent overflow-hidden mx-3 my-1.5" style={{
                    clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                  }} data-id="element-1424">
                      <div className="absolute inset-0 bg-emerald-600 translate-y-[-100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-1425" />
                      <span className="text-base font-light relative z-10 inline-flex items-center gap-2 text-emerald-600 group-hover/btn:text-white transition-colors duration-300" data-id="element-1426">
                        <MailIcon className="w-4 h-4" data-id="element-1427" />
                        Enquire
                      </span>
                    </div>
                  </motion.a>
                </div>
              </div>

              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-1428" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-1429" />
            </motion.div>

            {/* Consultation */}
            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} whileHover={{
            y: -8
          }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 h-full" style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
          }} data-id="element-1430">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 via-teal-400/10 to-cyan-400/10" data-id="element-1431" />
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-1432" />

              <div className="relative z-10 p-8 h-full flex flex-col" data-id="element-1433">
                <h4 className="text-2xl font-light text-stone-900 mb-6 tracking-tight" data-id="element-1434">
                  Consultation
                </h4>
                <ul className="space-y-3 flex-grow" data-id="element-1435">
                  <li className="flex items-start gap-3" data-id="element-1436">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1437" />
                    <span className="text-stone-700 font-light" data-id="element-1438">
                      Creative audit
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1439">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1440" />
                    <span className="text-stone-700 font-light" data-id="element-1441">
                      Brand alignment assessment
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1442">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1443" />
                    <span className="text-stone-700 font-light" data-id="element-1444">
                      Direction recommendations
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1445">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-1446" />
                    <span className="text-stone-700 font-light" data-id="element-1447">
                      Strategic planning
                    </span>
                  </li>
                </ul>
                <p className="text-sm text-stone-500 font-light mt-4 italic" data-id="element-1448">
                  *Ideal for existing brands seeking refresh
                </p>

                {/* Enquire Button */}
                <div className="mt-6" data-id="element-1449">
                  <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Consultation%20(Design%20Direction)&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Consultation%20package%20for%20Design%20Direction%2C%20which%20includes%3A%0D%0A%E2%80%A2%20Creative%20audit%0D%0A%E2%80%A2%20Brand%20alignment%20assessment%0D%0A%E2%80%A2%20Direction%20recommendations%0D%0A%E2%80%A2%20Strategic%20creative%20planning%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                  y: -2
                }} className="group/btn inline-block relative" data-id="element-1450">
                    <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                    clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                  }} data-id="element-1451" />
                    <div className="relative px-5 py-1.5 bg-transparent overflow-hidden mx-3 my-1.5" style={{
                    clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                  }} data-id="element-1452">
                      <div className="absolute inset-0 bg-emerald-600 translate-y-[-100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-1453" />
                      <span className="text-base font-light relative z-10 inline-flex items-center gap-2 text-emerald-600 group-hover/btn:text-white transition-colors duration-300" data-id="element-1454">
                        <MailIcon className="w-4 h-4" data-id="element-1455" />
                        Enquire
                      </span>
                    </div>
                  </motion.a>
                </div>
              </div>

              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-1456" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-1457" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Work Samples Section */}
      <section className="py-24 px-6 bg-white border-t border-stone-100" data-id="element-1458">
        <div className="max-w-7xl mx-auto" data-id="element-1459">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-center mb-20" data-id="element-1460">
            <h3 className="text-4xl md:text-5xl font-extralight text-stone-900 mb-6 tracking-tight" data-id="element-1461">
              Work Samples
            </h3>
            <div className="w-24 h-[1px] bg-emerald-600 mx-auto" data-id="element-1462" />
          </motion.div>

          {/* Project 1: BioMaxing */}
          <div className="mb-32" data-id="element-1463">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-center mb-12" data-id="element-1464">
              <h4 className="text-3xl md:text-4xl font-light text-stone-900 mb-3" data-id="element-1465">
                BioMaxing
              </h4>
              <p className="text-emerald-700 font-medium mb-6 tracking-wide uppercase text-sm" data-id="element-1466">
                Full Creative Direction
              </p>
              <p className="text-lg text-stone-600 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-1467">
                Co-founded startup directing the brand identity, UX/UI design
                and marketing strategy for a multi-platform biohacking and
                wellness application.
              </p>
            </motion.div>

            <ProjectCarousel slides={[{
            image: 'https://storage.yandexcloud.net/maria-images/images/brand%20vision.png',
            caption: 'Brand Vision'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/visual%20identity.png',
            caption: 'Visual Identity System'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Cross-platform.png',
            caption: 'Cross-Platform Direction'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/marketing%20creatives.png',
            caption: 'Marketing Creative'
          }]} data-id="element-1468" />
          </div>

          {/* Project 2: Fizkultura */}
          <div data-id="element-1469">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-center mb-12" data-id="element-1470">
              <h4 className="text-3xl md:text-4xl font-light text-stone-900 mb-3" data-id="element-1471">
                Fizkultura
              </h4>
              <p className="text-emerald-700 font-medium mb-6 tracking-wide uppercase text-sm" data-id="element-1472">
                Creative Direction & Brand Strategy
              </p>
              <p className="text-lg text-stone-600 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-1473">
                Fizkultura is a boutique fitness studio focused on conscious,
                body-aware and functional training, located in a rapidly
                expanding business cluster.
              </p>
            </motion.div>

            <ProjectCarousel slides={[{
            image: 'https://storage.yandexcloud.net/maria-images/images/studio%20concept.png',
            caption: 'Studio Concept Direction'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/brand%20identity%20fizra.png',
            caption: 'Brand Identity Development'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/space.png',
            caption: 'Space & Community Building'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/web%20presence.png',
            caption: 'Web Presence'
          }]} data-id="element-1474" />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-t from-emerald-50/40 via-stone-50 to-stone-50 border-t border-emerald-600/30" data-id="element-1475">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1476">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-1477">
            <h2 className="text-4xl md:text-5xl font-light mb-6 text-stone-900" data-id="element-1478">
              Have a specific request?
            </h2>
            <p className="text-xl text-stone-600 font-light mb-8" data-id="element-1479">
              Let's discuss what we can create together
            </p>
            <motion.a href="mailto:contact@maria-elina.com" whileHover={{
            y: -3
          }} className="group inline-block relative" data-id="element-1480">
              {/* Outer border layer */}
              <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
              clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
            }} data-id="element-1481" />
              {/* Inner filled layer */}
              <div className="relative px-6 py-2 bg-emerald-600 text-white overflow-hidden mx-3 my-1.5" style={{
              clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
            }} data-id="element-1482">
                <div className="absolute inset-0 bg-emerald-700 translate-y-[100%] group-hover:translate-y-0 transition-transform duration-300" data-id="element-1483" />
                <span className="text-lg font-light relative z-10 inline-flex items-center gap-2" data-id="element-1484">
                  <MailIcon className="w-4 h-4" data-id="element-1485" />
                  Get in Touch
                </span>
              </div>
            </motion.a>
          </motion.div>
        </div>
      </section>
    </div>;
}